import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ObjectivePartsValidationSchema } from "../schemas/objectiveParts.schema";

interface UseCreateObjectivePartProps {
  onSuccess?: () => void
  onError?: (error: any) => void
}

const useCreateObjectivePart = ({ onSuccess, onError }: UseCreateObjectivePartProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createMaintenanceObjectivePart'],
    mutationFn: (data: ObjectivePartsValidationSchema) => {
      const payload = {
        objective_part: {
          display_name: data.display_name,
          system_parts_attributes: data.system_parts_attributes.map((option) => ({
            system_id: option.value,
          })),
        }
      }

      return privateAxios.post('/maintenance/objective_parts', payload);
    },
    onSuccess,
    onError,
  });
}

export default useCreateObjectivePart;
